import { Checkbox, Space, Card } from 'antd';
import React from 'react';

function Checkboxes() {
  return (
    <Card title="Checkboxes">
      <Space>
        <Checkbox defaultChecked={true}/>
        <Checkbox indeterminate={true} />
        <Checkbox />
        <Checkbox defaultChecked={true} disabled/>
        <Checkbox indeterminate={true} disabled />
      </Space>
    </Card>
  )
}

export default Checkboxes;
